function FreeTrialButton({ onClick, className = "", label = "free trial" }) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center justify-center w-[165px] h-[50px] rounded-full text-white text-sm font-medium lowercase whitespace-nowrap transition-opacity hover:opacity-90 cursor-pointer ${className}`}
      style={{ backgroundColor: "#721AF0" }}
    >
      {label}
    </button>
  );
}

export default FreeTrialButton;
